import React from 'react';
import { Pagination } from 'antd';
import {
  PaginationContainer,
  PageSizeContainer,
  StyledSelect,
  ItemsPerPageText
} from '../../styled';

const TablePagination = ({
  current,
  pageSize,
  total,
  onChange,
  onPageSizeChange,
  className,
  showQuickJumper = true,
  showSizeChanger = true,
}) => {
  const handlePageChange = (page, size) => {
    onChange(page, size);
  };

  const handleSizeChange = (size) => {
    onPageSizeChange(size);
  };

  // Don't show pagination if there's only one page
  if (total <= pageSize) {
    return null;
  }

  return (
    <PaginationContainer className={className}>
      <Pagination
        current={current}
        pageSize={pageSize}
        total={total}
        onChange={handlePageChange}
        showQuickJumper={showQuickJumper && total > 50} // Only show quick jumper for larger datasets
        showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
        size="default"
      />
      
      {showSizeChanger && (
        <PageSizeContainer>
          <StyledSelect
            value={pageSize}
            onChange={handleSizeChange}
            dropdownMatchSelectWidth={false}
          >
            <StyledSelect.Option value={5}>5</StyledSelect.Option>
            <StyledSelect.Option value={10}>10</StyledSelect.Option>
            <StyledSelect.Option value={25}>25</StyledSelect.Option>
            <StyledSelect.Option value={50}>50</StyledSelect.Option>
          </StyledSelect>
          <ItemsPerPageText>Items per page</ItemsPerPageText>
        </PageSizeContainer>
      )}
    </PaginationContainer>
  );
};

export default TablePagination;